import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { LandingPageCssFeature } from './landingPageCss.types'
import { landingPagesCss } from './landingPageCssCompNode'
import { landingPageCssDomApplier } from './landingPageCssDomApplier'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import { autoHeightWrapper } from '../autoHeightWrapper/autoHeightWrapperCompNode'

export const landingPageCssFeature: LandingPageCssFeature = {
	featureName: 'landingPages',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { landingPagesCss: landingPagesCss(false) },
	intermediateNodes: { compLayout: compInfoNodes.compLayout },
	dataMaps: ['document_data'],
	domApplier: landingPageCssDomApplier,
}

export const editorLandingPageCssFeature: LandingPageCssFeature = {
	...landingPageCssFeature,
	renderableNodes: { landingPagesCss: landingPagesCss(true) },
	intermediateNodes: { ...landingPageCssFeature.intermediateNodes, autoHeightWrapper },
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(landingPageCssFeature)
}
export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorLandingPageCssFeature)
}
